export const convert0To00 = (unit: any): string => {
    var convert = "0" + unit
    return convert.substring(convert.length - 2, convert.length);
}
export const convertDate = (data: Date): string => {
    return data.getFullYear() + '-' + convert0To00(data.getMonth() + 1) + '-' + convert0To00(data.getDate())
}
export const formatarTelefone = (numero: string): string | null => {
    // Remove todos os caracteres que não são dígitos
    const numerosApenas = numero.replace(/\D/g, '');

    // Verifica se a string contém a quantidade esperada de dígitos (10 ou 11)
    if (numerosApenas.length !== 10 && numerosApenas.length !== 11) {
        console.error("O número de telefone deve conter 10 ou 11 dígitos.");
        return null;
    }

    // Aplica a formatação com base no comprimento do número
    if (numerosApenas.length === 11) {
        // Formato para números com 11 dígitos: (XX) X XXXX-XXXX
        return numerosApenas.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4');
    } else {
        // Formato para números com 10 dígitos: (XX) XXXX-XXXX
        return numerosApenas.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
}
/**
 * Formata um número de telefone para o padrão brasileiro (XX) 9 XXXX-XXXX.
 * Se o número tiver 10 dígitos, o '9' é adicionado automaticamente após o DDD.
 * @param numero A string do número de telefone a ser formatada.
 * @returns A string do telefone formatado ou null se a entrada for inválida.
 */
export const formatarCelular = (numero: string): string | null => {
  // 1. Remove todos os caracteres que não são dígitos
  const numerosApenas = numero.replace(/\D/g, '');

  let numeroParaFormatar: string;

  // 2. Verifica o comprimento e adiciona o nono dígito se necessário
  if (numerosApenas.length === 10) {
    // Se tem 10 dígitos, insere o '9' após o DDD
    const ddd = numerosApenas.slice(0, 2);
    const restoDoNumero = numerosApenas.slice(2);
    numeroParaFormatar = `${ddd}9${restoDoNumero}`;
  } else if (numerosApenas.length === 11) {
    // Se já tem 11 dígitos, usa como está
    numeroParaFormatar = numerosApenas;
  } else {
    // Se não tiver 10 ou 11 dígitos, é considerado inválido
    console.error("Entrada inválida. O número deve conter 10 ou 11 dígitos.");
    return null;
  }

  // 3. Aplica a formatação final, agora que garantidamente temos 11 dígitos
  // Formato: (XX) 9 XXXX-XXXX
  return numeroParaFormatar.replace(
    /(\d{2})(\d{1})(\d{4})(\d{4})/,
    '($1) $2 $3-$4'
  );
}